<template>
  <main :class="{'boxPadding': isBox}">
    <!-- <section class="search container">
      <div class="row">
        <div class="col-12">
          <form class="form row">
            <div class="col-5">
              <div class="input-group input-lg">
                <div class="input">
                  <input
                  type="text"
                  name="keyowrd"
                  id="keyowrd"
                  class="form-control"
                  v-model="keyword"
                  placeholder="可用身分證、姓名、保單號碼查詢">
                </div>
                <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.stop.prevent="doSearch()">
                  <i class="icon-search i-24"></i>
                </button>
              </div>
            </div>
            <div class="col-7">
              <div class="form-group text-center mt-1">
                <a class="btn btn-default m-0">列出所有保校家庭</a>
                <span class="text mx-2">或</span>
                <v-select :options="[]" placeholder="依群組查詢" class="v-select-inline" />
                <a class="btn btn-default m-0">查詢</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div class="container-fluid">
      <h4 class="text-green">戶長列表</h4>
      <p>請選擇你想做建議的家庭</p>
      <div class="button-grid five-items mt-2">
        <a class="btn btn-border-green"
        v-for="(cus, i) in customers"
        :key="`customer-btn-${i}`"
        @click="userSelect(cus.id)">
          {{cus.name}}
        </a>
      </div>
    </div> -->
    <!-- <div class="iframe-container"  v-if="UserInfo.divNo === '9400400' || UserInfo.id == 'C18768708E' || UserInfo.id == 'C121021422'">  -->
    <div class="iframe-container">
      <iframe :src="frameSrc" frameborder="0" :key="'iframe-'+frameSrc"></iframe>
    </div>
    <warning-modal
      :open="warningModalOpen"
      :message="warningData[currentWarningType].message"
      :cancelText="`列出所有家戶`"
      @close="warningClose"
      @submit="warningSubmit"/>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from '../../mixins/common';
import WarningModal from '@/desktop/components/WarningModal';
import { getFamilyMembers } from '@/service'

// https://tcrm.cathaylife.com.tw/PolicyAdjustmentWebApplication/EntryPage.ashx?HolderID=E12345678A&RunAsID=N13456789A&logintag=
// let custFrameSrc = 'https://tcrm.cathaylife.com.tw/eisn/shunt_program.asp?source=mycrm&HolderID='
// let custFrameSrc = 'https://tcrm.cathaylife.com.tw/PolicyAdjustmentWebApplication/EntryPage.ashx?HolderID=E12345678A&RunAsID=N13456789A&logintag='
let custFrameSrc =
  "https://tcrmpa.cathaylife.com.tw/PolicyAdjustmentWebApplication/EntryPage.ashx?env=" + (window.env||'') + "&source=mycrm&HolderID=";
if (window.location.href.indexOf("//mycrm") !== -1) {
  custFrameSrc = "https://crmpa.cathaylife.com.tw/PolicyAdjustmentWebApplication/EntryPage.ashx?source=mycrm&HolderID=";  
}

export default {
  name: "InsuranceCheck",
  mixins: [commonMixin],
  data() {
    return {
      selected: null,
      keyword: "",
      // frameSrc: process.env.NODE_ENV == "development"
      //               ? 'https://tcrm.cathaylife.com.tw/PolicyAdjustmentWebApplication/EntryPage.ashx?HolderID=E12345678A&RunAsID=N13456789A&logintag='
      //               : '',
      frameSrc: custFrameSrc,
      customers: [
        { id: 1, name: "林怡君" },
        { id: 2, name: "陳志明" },
        { id: 3, name: "陳一明" },
        { id: 1, name: "陳名醫" },
        { id: 1, name: "林家豪" },
        { id: 1, name: "林志明" },
        { id: 1, name: "林一明" },
        { id: 1, name: "林名醫" }
      ],
      custCheckLeader: {},
      warningModalOpen: false,
      currentWarningType: 'confirmOK',
      warningData: {
        confirmOK: {
          message: '',
          submit: 'confirmOK'
        }
      },
      fromMv:'',
      parameter:{
    	  userType:''
      }
    };
  },
  components: { WarningModal },
  computed: {
    ...mapGetters(["UserInfo", "CustInfo"]),
    isBox() {
      return this.UserInfo.userType === 'box';
    }
  },
  methods: {
    ...mapActions(["updateCustID", "updateQueryKeyword", "updateSerNo", "setPageLock"]),
    userSelect(i) {
      this.selected = {
        HolderID: "E12345678A",
        RunAsID: "小○小"
      };
      // this.$router.push({
      //   name: 'insurance-check',
      //   query: {
      //     HolderID: 'E12345678A',
      //     RunAsID: "小○小"
      //   }
      // })
      window.location.hash = `#/${this.$route.name}?cusid=E12345678A&cusname=小○小`;
    },
    detectHash() {
      let obj = []
      let objKey = []
      if(window.location.href.replace(/.*check\?{0,1}/,'') !== '') {
        //  過濾出 key, value 備用
        obj = window.location.href.replace(/.*check\?/,'').split('&').map(item => {
          return {key: item.replace(/=.*/,''), value: item.replace(/.*=/,''),}
        })
        //  過濾出 key 備用
        objKey = obj.map(item => {return item.key})
      }

      // 判斷是否有 query
      if (obj.length !== 0) {
        // iframe redirect
        if (objKey.includes('switch')) {   //  如果 switch 有值
          // 取出 cusid 的值
          let switchVal = ''
          obj.forEach(item => {if(item.key == 'switch'){switchVal = item.value}})
          if (!switchVal.includes('~')) { // 正常ID
            this.updateCustID(decodeURI(switchVal))
            this.updateSerNo('')
            localStorage.CustID = decodeURI(switchVal)
            localStorage.SerNo = ''
          } else {  // 無ID 流水編
            this.updateCustID('')
            this.updateSerNo(switchVal)
            localStorage.CustID = ''
            localStorage.SerNo = switchVal
          }
          return false
        }
        // 取出 cusid 的值
        let cusidVal = ''
        obj.forEach(item => {if(item.key == 'cusid'){cusidVal = item.value}})
        if (cusidVal == 'list') {
          this.updateQueryKeyword(""); // 事先 initialize 再導頁至 客戶搜尋
          this.$store.dispatch("updaCustType", ["1", "2", "3", "4", "5", "6"]);
          this.$router.push({ path: "/search-result" });
        } else {  // 導頁至 客戶基本資料
          if(!cusidVal.includes('~')){ // 正常ID
            this.updateCustID(decodeURI(cusidVal))
            this.updateSerNo('')
            localStorage.CustID = decodeURI(cusidVal)
            localStorage.SerNo = ''
          } else {  // 流水編
            this.updateCustID('')
            this.updateSerNo(cusidVal)
            localStorage.CustID = ''
            localStorage.SerNo = cusidVal
          }
          this.$router.push({ path: `/detail/CustID/tab/1` })
        }
      } else {
        // back to initial page
      }
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    warningSubmit () {
      // 確認，進入家戶
      let src;
    
      if(this.custCheckLeader) {
        // 如果當前瀏覽的客戶非戶長，則使用custCheckLeader
        src = custFrameSrc + (this.custCheckLeader.personalid ? this.custCheckLeader.personalid : this.custCheckLeader.csidno);
      } else {
        // 代入客戶ID 如果沒有ID 代入流水編 serNo
        if(this.CustInfo.ID !== '' && this.CustInfo.ID !== undefined) {
          src = custFrameSrc + this.CustInfo.ID
        } else {
          src = custFrameSrc + this.CustInfo.serNo
        }
      }
      this.frameSrc = src + "&RunAsId=" + encodeURIComponent(this.UserInfo.eid) + this.fromMv + this.parameter.userType;
      this.panelClose('warningModalOpen')
    },
    warningClose() {
      // 取消，進入列表
      this.frameSrc = custFrameSrc + "&RunAsId=" + encodeURIComponent(this.UserInfo.eid) + this.parameter.userType
      this.panelClose('warningModalOpen')
    }
  },
  created() {
    console.log('do insurance init!!!!!!!!!!')
    
    this.detectHash();
    
    let src = '';
    //20210708新增 從新保健按鈕來
    if(localStorage.fromMv === 'Y'){
      if(!src.includes('fromMv=Y'))
      this.fromMv = '&fromMv=Y'
      localStorage.fromMv = ''
    }
    
    this.parameter.userType = this.UserInfo.userType ? "&userType=" + this.UserInfo.userType : "";
    
    // 只有在客戶的「基本資料」頁面過來時才需代入 custID
    const checkRegex = /\/detail\//
    if (checkRegex.test(this.$store.state.fromPagePath)) {
      // 代入客戶ID 如果沒有ID 代入流水編 serNo
      if(this.CustInfo.ID !== '' && this.CustInfo.ID !== undefined) {
        src = custFrameSrc + this.CustInfo.ID
        
      } else {
        src = custFrameSrc + this.CustInfo.serNo
      }
    } else if(this.$route.params.checkCust) {
      // 只有在「建議書」頁面過來時才需跳出家戶確認視窗並代入 custID
      if((this.CustInfo.ID || this.CustInfo.serNo) && this.CustInfo.name && this.CustInfo.familyLeader) {
        // 有ID或流水邊號，且有姓名且為戶長則直接跳轉
        this.custCheckLeader = undefined
        this.currentWarningType = 'confirmOK'
        this.warningData.confirmOK.message = `請問您是否要繼續使用「${this.$store.state.custInfo.name}」的家戶?`
        this.panelOpen('warningModalOpen')
      } else {
        // 取得戶長
        var custID;
        if(this.CustInfo.ID) {
          custID = this.CustInfo.ID
        } else {
          custID = this.CustInfo.serNo
        }

        getFamilyMembers(this.$store.state.userInfo.id, custID).then(result=>{
          if(result.header && result.header.status == '200' && result.body.familymembers) {
            let familyLeader = result.body.familymembers.find(member=> (member.relation == 0 || member.familyrl == 0))
            this.custCheckLeader = familyLeader
            this.currentWarningType = 'confirmOK'
            this.warningData.confirmOK.message = `請問您是否要繼續使用「${familyLeader.name}」的家戶?`
            this.panelOpen('warningModalOpen')
          }
        });
      }
    } else {
      // 取得戶長
      var custID;
      if(this.CustInfo.ID) {
        custID = this.CustInfo.ID
      } else {
        custID = this.CustInfo.serNo || ''
      }
        
      src = custFrameSrc + custID
    }
    
    this.frameSrc = src ? (src + "&RunAsId=" + encodeURIComponent(this.UserInfo.eid) + this.fromMv + this.parameter.userType) : custFrameSrc;
    window.addEventListener("hashchange", this.detectHash, false)
  },
  destroyed () {
    // 移除監聽 
    // console.log('被砍掉了喔')
    window.removeEventListener("hashchange", this.detectHash)
  }
};
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>